module.exports = __webpack_public_path__ + "assets/vastgoedmarkt.ff7dce62.svg";